var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "theme-content" },
    [
      _c(
        "div",
        { staticClass: "zhutiBox", on: { click: _vm.drawerShow } },
        [_c("svg-icon", { attrs: { "icon-class": "zhuti" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "更换主题",
            visible: _vm.drawer,
            direction: _vm.direction,
            "append-to-body": "",
            "modal-append-to-body": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("div", [
            _c(
              "div",
              { staticClass: "colordisc" },
              _vm._l(_vm.colordiscList, function (item, index) {
                return _c(
                  "div",
                  { staticClass: "colordiscListClass" },
                  [
                    _c("span", { staticClass: "textClass" }, [
                      _vm._v(_vm._s(item.text)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: item.text,
                          placement: "top",
                        },
                      },
                      [
                        _c("div", { staticClass: "colorBox" }, [
                          _c(
                            "div",
                            {
                              staticClass: "disc",
                              style: { background: item.color },
                              on: {
                                click: function ($event) {
                                  return _vm.handelcolordisc(index, item)
                                },
                              },
                            },
                            [
                              item.isshow
                                ? _c("i", { staticClass: "el-icon-check" })
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "disc",
                            style: { background: item.asideBack },
                          }),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }